<template>
  <div>
    <Loader v-if="loading"/>

    <ClientStrategyForm
      v-if="userCanEdit && showForm"
      :strategies="strategies"
      :stage="stage"
      :stages="data"
      :lastStageDate="lastStageDate"
      :unfinishedGoals="unfinishedGoals"
      v-on:submit="submitForm"
      v-on:cancel="closeForm"/>

    <Flash v-if="error" :message="error" type="danger" v-on:close="error = ''"/>
    <Flash v-if="success" :message="success" type="success" v-on:close="success = ''"/>

    <div
      v-if="userCanEdit"
      class="py-3">
      <button
        class="btn btn-primary"
        @click="createStage">
        Добавить этап
      </button>
    </div>

    <ClientStrategyList
      title="Текущие стратегии"
      :strategies="strategies"
      :stages="current"
      v-on:select="selectStage"
      v-on:change="changeStatus"
      :userCanChangeStatus="userCanChangeStatus" />

    <ClientStrategyList
      title="Завершенные стратегии"
      :strategies="strategies"
      :stages="past"
      v-on:select="selectStage"
      v-on:change="changeStatus"
      :userCanChangeStatus="userCanChangeStatus" />
  </div>
</template>

<script>
import Loader from '../common/Loader';
import Flash from '../common/Flash';
import ClientStrategyList from './strategy/List';
import ClientStrategyForm from './strategy/Form';

export default {
  name: 'ClientStrategy',

  components: {
    Loader,
    Flash,
    ClientStrategyList,
    ClientStrategyForm,
  },

  props: ['client'],

  data() {
    return {
      loading: false,
      error: '',
      success: '',
      showForm: false,
      stageId: null,
      unfinishedGoals: [],
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    stage() {
      if (!this.userCanEdit) {
        return;
      }

      return this.stages.find(i => i.id === this.stageId);
    },

    strategies() {
      return this.$store.state.strategy.strategies;
    },

    stages() {
      return this.$store.getters.clientStages(this.client.id);
    },

    data() {
      return this.stages.map(stage => {
        //@todo move to model
        stage.goals.map(goal => {
          const strategy = this.strategies.find(i => i.id === goal.strategy);

          if (typeof strategy !== 'undefined') {
            goal.startegyTitle = strategy.title;
            goal.startegyId = strategy.id;
          }
        });

        return stage;
      });
    },

    current() {
      return this.data.filter(i => i.finished === false);
    },

    past() {
      return this.data.filter(i => i.finished === true);
    },

    lastStageDate() {
      let lastStageDate = new Date();

      for(const stage of this.stages) {
        if (stage.dateTo.getTime() > lastStageDate.getTime()) {
          lastStageDate = stage.dateTo;
        }
      }

      return lastStageDate;
    },

    userCanEdit() {
      return this.$security.voters.strategy.canEdit(this.$store.state.user);
    },

    userCanChangeStatus() {
      return this.$security.voters.strategy.canChangeStatus(this.$store.state.user);
    },
  },

  methods: {
    async loadData() {
      try {
        this.loading = true;

        await Promise.all([
          this.$store.dispatch('STRATEGY_LOAD_STRATEGIES'),
          this.$store.dispatch('STRATEGY_LOAD_STAGES', this.client.id),
        ]);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    createStage() {
      this.unfinishedGoals = [];

      let lastFinished = null;

      for (const stage of this.past) {
        if (lastFinished === null || stage.dateTo > lastFinished.dateTo) {
          lastFinished = stage;
        }
      }

      if (lastFinished !== null) {
        for (const goal of lastFinished.goals) {
          if (goal.isCanceled()) {
            this.unfinishedGoals.push(goal.startegyId);
          }
        }
      }

      this.showForm = true;
    },

    selectStage(id) {
      if (!this.userCanEdit) {
        return;
      }

      const stage = this.stages.find(i => i.id === id);

      this.unfinishedGoals = [];

      if (typeof stage !== 'undefined') {
        this.stageId = stage.id;
        this.showForm = true;
      }
    },

    async submitForm(data) {
      if (!this.userCanEdit) {
        return;
      }

      this.loading = true;

      try {
        const { id, title, goals, dateFrom, dateTo } = data;
        const params = {
          id,
          user: this.client.id,
          title,
          goals,
          dateFrom,
          dateTo,
        };

        if (typeof params.id !== 'undefined') {
          await this.$store.dispatch('STRATEGY_UPDATE_STAGE', params);

          this.success = 'Этап успешно обновлен';
        } else {
          await this.$store.dispatch('STRATEGY_ADD_STAGE', params);

          this.success = 'Этап успешно добавлен';
        }
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
      this.closeForm();
    },

    closeForm() {
      this.stageId = null;
      this.showForm = false;
    },

    async changeStatus({goal, stage, status}) {
      if (!this.userCanChangeStatus) {
        return;
      }

      this.loading = true;

      try {
        const params = {id: goal.id, stage: stage.id, status, user: this.client.id};

        await this.$store.dispatch('STRATEGY_CHANGE_GOAL_STATUS', params);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    }
  },
};
</script>
